var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 7.33334H28.0002C25.4228 7.33334 23.3335 9.42268 23.3335 12C23.3335 14.5773 25.4228 16.6667 28.0002 16.6667H36.0002C38.5775 16.6667 40.6668 14.5773 40.6668 12C40.6668 9.42268 38.5775 7.33334 36.0002 7.33334Z",
    stroke: "#7B7BDF",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4572 10.7549C21.3759 11.1836 21.3333 11.6261 21.3333 12.0785C21.3333 13.021 21.5181 13.9203 21.8533 14.7423C20.4358 14.7934 19.2244 14.8787 18.1621 15.0215C15.701 15.3524 14.6477 15.9243 13.9526 16.6193C13.2576 17.3143 12.6857 18.3677 12.3549 20.8288C12.0085 23.405 12 26.8587 12 32V37.3333C12 42.4747 12.0085 45.9283 12.3549 48.5045C12.6857 50.9656 13.2576 52.0189 13.9526 52.7141C14.6477 53.4091 15.701 53.9811 18.1621 54.3117C20.7383 54.6581 24.1919 54.6667 29.3333 54.6667H34.6667C39.808 54.6667 43.2616 54.6581 45.8379 54.3117C48.2989 53.9811 49.3523 53.4091 50.0475 52.7141C50.7424 52.0189 51.3141 50.9656 51.6451 48.5045C51.9915 45.9283 52 42.4747 52 37.3333V32C52 26.8587 51.9915 23.405 51.6451 20.8288C51.3141 18.3677 50.7424 17.3143 50.0475 16.6193C49.3523 15.9243 48.2989 15.3524 45.8379 15.0215C44.7757 14.8787 43.5643 14.7934 42.1467 14.7423C42.4819 13.9203 42.6667 13.021 42.6667 12.0785C42.6667 11.6261 42.624 11.1836 42.5427 10.7549C47.6088 10.9563 50.7029 11.618 52.8757 13.7909C56 16.9151 56 21.9434 56 32V37.3333C56 47.3899 56 52.4184 52.8757 55.5424C49.7517 58.6667 44.7232 58.6667 34.6667 58.6667H29.3333C19.2767 58.6667 14.2484 58.6667 11.1242 55.5424C8 52.4184 8 47.3899 8 37.3333V32C8 21.9434 8 16.9151 11.1242 13.7909C13.2971 11.618 16.3911 10.9563 21.4572 10.7549Z",
    fill: "#7B7BDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 36L30.6665 40L38.6665 32",
    stroke: "#7B7BDF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7912a6d3df150fec3d1223eb9408790f.svg";
export { ForwardRef as ReactComponent };